import actions from './actions'

export default {
  actions
}
